<template>
  <v-dialog width="500" v-model="showAdvanceReportForm">
    <v-card>
      <v-card-title class="secondary white--text">
        <span> Update Advance Report Config</span>

        <v-spacer></v-spacer>

        <v-btn icon @click="resetForm(), (showAdvanceReportForm = false)">
          <v-icon class="white--text">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-2">
        <v-form ref="AdvanceReportForm" v-if="showAdvanceReportForm" v-model="isValid">
          <v-row class="my-0">
            <v-col cols="12" class="Form-Columns">
              <InputField type="text" label="Report Name *" readonly hide-details="auto" v-model="formDetails.name"
                :error-messages="formErrors.name" @input="delete formErrors.name" />
            </v-col>

            <v-col cols="12" class="Form-Columns">
              <InputField type="text" label="Report Type *" readonly hide-details="auto"
                v-model="formDetails.report_type" :error-messages="formErrors.report_type"
                @input="delete formErrors.report_type" />
            </v-col>

            <v-col cols="12" class="Form-Columns">
              <MultiSelect label="Frequency*" :items="ReportFrequencys" itemText="display_name" itemValue="value"
                hide-details="auto" v-model="formDetails.frequency" />

            </v-col>
            <v-col cols="12" class="Form-Columns">
              <InputField type="text" label="Days Of Month *" hide-details="auto" v-model="formDetails.day_of_month"
                :error-messages="formErrors.day_of_month" @input="delete formErrors.day_of_month" />
            </v-col>
            <v-col cols="12" class="Form-Columns">
              <InputField type="text" label="Recipients " hide-details="auto" v-model="formDetails.recipients"
                :error-messages="formErrors.recipients" @input="delete formErrors.recipients" />
            </v-col>

          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="justify-end">
        <v-btn color="primary" depressed :disabled="!isValid" @click="submitForm">
          Submit
        </v-btn>

        <v-btn class="ml-2" color="secondary" v-if="!editMode" depressed @click="resetForm">
          Reset
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InputField from "@/components/FormBaseComponents/InputField.vue";
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";
import SelectField from "@/components/FormBaseComponents/SelectField.vue";
import { ReportFrequency } from "@/utils/choices";

export default {
  components: {
    InputField,
    SelectField,
    MultiSelect,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    editAdvanceReportID: {
      type: [Number, null],
      default: null,
    },
  },
  watch: {
    value(val) {
      if (val) {
        if (this.editMode) {
          this.getadvanceReportObjects(this.editAdvanceReportID);
        }
      } else {
        this.resetForm();
      }
    },
  },
  computed: {
    showAdvanceReportForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      formDetails: {},
      formErrors: {},
      isTextInput: false,
      isValid: true,
      ReportFrequencys: ReportFrequency,
    };
  },
  methods: {
    submitForm() {
      this.$bus.$emit("showLoader", true);

      const payload = {
        ...this.formDetails,

        frequency:
          typeof this.formDetails.frequency === "object"
            ? this.formDetails.frequency?.value
            : this.formDetails.frequency,

        recipients: Array.isArray(this.formDetails.recipients)
          ? this.formDetails.recipients
          : this.formDetails.recipients
            ?.split(",")
            .map(e => e.trim())
            .filter(Boolean),
      };



      this.$api.advancedReport
        .updateAdvanceReportDetails({
          id: payload.id,
          data: payload,
        })
        .then(() => {
          this.$bus.$emit("showLoader", false);
          this.showAdvanceReportForm = false;
        this.$emit('refreshList')
        })
        .catch(err => {
          this.$bus.$emit("showLoader", false);
          this.formErrors = err.data || {};
        });
    },



    resetForm() {
      if (this.$refs.AdvanceReportForm) {
        this.$refs.AdvanceReportForm.reset();
      }
      this.formDetails = {};
    },

    getadvanceReportObjects(id) {
      this.$bus.$emit("showLoader", true);
      this.$api.advancedReport
        .getadvanceReportObject(id)
        .then((res) => {
          this.$bus.$emit("showLoader", false);
          this.formDetails = res.data;
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
  },
};
</script>
